import { makeStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";

export default makeStyles(() => ({
  linha: {
    display: "flex",
    alignItems: "center",
  },
  chevron: {
    marginLeft: 4,
    color: grey[600],
    cursor: "pointer",
    transition: "transform 150ms",
  },
  chevronAberto: {
    transform: "rotate(180deg)",
  },
}));
